import React, { Component, createRef } from "react";
import { POST, loading, token, alert } from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";

import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: ""
    };
  }
  componentDidMount() {
    loading(false);
  }
  render() {
    const {search} = this.state;
    return (
      <div className="w-100 min-vh-100 bg-dark position-relative">
        <Navbar />
        <div className="mb-5 text-white">
          <div className="container py-5 text-center">
            <h2 className="fw-bold">เติมเกม</h2>
            <h5 className="mb-3">
              เติมเกมออนไลน์ เติมเกมมือถือ ตลอด 24 ชม. กับ <b>SwiftGamePay</b>
            </h5>
            <small>
              แหล่งเติมเกมออนไลน์ ที่มีให้เติมมากกว่า 30 เกม
              เราเปิดให้บริการเติมเกม ไม่ว่าจะเป็น PUB G Mobile, rov, genshin
              impact, Hokai: Star Rail และเกมชั้นนำมากมาย พร้อมให้บริการตลอด 24
              ชม. สะดวก รวดเร็ว ปลอดภัย ไม่มีโกง การันตียอดผู้ติดตามร้านกว่า 5
              แสนซัพ มาพร้อมกับบริการเติมเกมแบบผ่อนได้ ผ่อนชำระนานสูงสุดถึง 10
              เดือน เท่านั้นยังไม่พอ เติมเกมกับเรา ได้เงินคืน ได้ส่วนลด กับ
              SwiftGamePay ที่ใช้แทนเงินสดได้ ( 1 coin = 1 บาท )
              และโปรโมชั่นพิเศษมากมาย ตลอดทั้งเดือน ทั้งปี เติมเกมคุ้มขนาดนี้
              ไม่ต้องไปเติมร้านไหน เติมร้านเรา SwiftGamePay No.1 เรื่องเติมเกม
            </small>
          </div>
          </div>
        <div className="container mx-auto my-5">
          <div className="row">
            <div className="col-12 col-lg-3 mb-3">
              <div className="card p-3 bg-dark rounded-3" style={{border: "1px solid #494343"}}>
                <h5 className="fw-bold text-white mb-3">ตัวกรอง</h5>
                <input className="form-control" placeholder="ค้นหาเกม..." onChange={(e)=>{this.setState({search:e.target.value})}} value={search}></input>
              </div>
            </div>
            <div className="col-12 col-lg-9">

          <div className="row">
            {global.game.filter(e => !search || ((e.name).toLowerCase()).includes(search.toLowerCase())).map((item,index) => (
              <div
                className="col-4 col-sm-4 col-md-3 col-xl-2 mb-3 product pointer"
                title={item.name}
                onClick={() => {
                  window.location.href = "/payment-game?id="+index
                }}
              >
                <div className="card p-2 bg-dark rounded-4" style={{border: "1px solid #494343"}}>
                <img
                  src={require(`../assets/images/game/image-${String(index + 2).padStart(2, "0")}.png`)}
                  alt=""
                  className="w-100 hpx-120 mb-1 mx-auto rounded-4"
                  style={{objectFit:"cover"}}
                />
                <div className="overflow-hidden px-2">
                  <b className="text-white text-nowrap" style={{textOverflow:"ellipsis"}}>{item.name}</b>
                </div>
                </div>
              </div>
            ))}
          </div>
            </div>
          </div>
          <div className="w-100 mb-5 p-3 text-white">
            <h5>หมายเหตุ</h5>
            <ul>
              <li>
                หากชำระเงินเสร็จสิ้นแล้ว แพ็กเกจที่ซื้อจะเข้าในบัญชีอัตโนมัติ
              </li>
              <li>หากกรอกข้อมูลผิด จะไม่สามารถคืนเงินหรือยกเลิกได้</li>
              <li>หลังจากชำระเงินเสร็จสิ้น จะไม่สามารถยกเลิกได้</li>
              <li>
                มีการยืนยันตัวตนด้วยบัตรประชาชนหรือทาง SMS
                ขึ้นอยู่กับช่องทางการชำระเงิน (ครั้งแรก)
              </li>
              <li>
                การยืนยันตัวตนด้วยบัตรประชาชนจะมีค่าธรรมเนียม 20 บาท
                (ขณะนี้อยู่ในช่วงฟรีค่าธรรมเนียม)
              </li>
              <li>
                หากชำระเงินเสร็จสิ้นแล้ว แต่การซื้อล้มเหลว จะคืน coin
                ให้ตามจำนวนเงินที่ซื้อ (ไม่รวมค่าบริการ)
              </li>
              <li>สามารถใช้ coin ที่คืนให้ นำมาซื้อแพ็กเกจได้</li>
            </ul>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}
